    import { ChangeDetectorRef, Component, EventEmitter, forwardRef, inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
    import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
    import { BehaviorSubject, catchError, debounceTime, finalize, Observable, Subject, Subscription, switchMap } from "rxjs";
    import { Variable } from "src/app/forms/formula-tester/formula-tester.component";
    import { HTTPService } from "src/app/services/http.service";
    import { StringUtils } from "../utils/StringUtils";

    export interface SearchProperties{
        placeholder?:string;
        size?:string;
        showKey?:boolean;
        showPresentation?:boolean;
        entityName:string;
        fields:{keyField:string, valueField:string};
        condition?:string;
        disabled?:boolean;
        dataValue?:any,
        type?:'sql' | 'mongo' | 'api';
    }

    export interface Option {
        key: any;
        value: any;
    }


    @Component({
        selector: 'search-input-new',
        templateUrl: './search-input-new.component.html',
        styleUrl: './search-input-new.component.scss',
        standalone: false,
        providers: [
        {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SearchInputNewComponent),
        multi: true
        },
        HTTPService
    ]

    })



    export class SearchInputNewComponent implements OnInit, OnDestroy,  ControlValueAccessor  {
    
        @Output() onClearData:EventEmitter<any> = new EventEmitter<any>();
        @Output() onChangeData:EventEmitter<any> = new EventEmitter<any>();
        @Output() onInit:EventEmitter<any> = new EventEmitter<any>();
        @Output() onSelect:EventEmitter<any> = new EventEmitter<any>();
        list:any[] = [];
        @Input() searchProperties:SearchProperties;
        @Input() variables:Variable[] = [];
        @Input() changes:Subject<any>;
        searchChange$ = new Subject<any>();
        optionList: {key:string, value:string}[] = [];
        selectedValue?: string;
        loading = false;
        sub: Subscription;

        value: any = null;
        disabled = false;


        constructor(private cd:ChangeDetectorRef, public http: HTTPService){}

        onChange = (value: any) => {};
        onTouched = () => {};

        writeValue(value: any): void {
            this.value = value;

            if ( value != null && value!= ''){
                this.onSearch(value);
            }
            
            if ( value!= null && value!= '' ){
                this.onChangeData.emit(value);
            }

        }
        registerOnChange(fn: any): void {
            this.onChange = fn;

        }
        registerOnTouched(fn: any): void {
            this.onTouched = fn;
        }
        setDisabledState?(isDisabled: boolean): void {
            this.disabled = isDisabled;
        }


        onSearch(value:any): void {
            this.loading = true;
            this.searchChange$.next(value);
        }

        
        
        ngOnDestroy(): void {
            this.searchChange$.complete();
            if ( this.sub!= null ){
                this.sub.unsubscribe();
            }
        }

        ngOnInit(): void {
            
            this.searchChange$
            .pipe(
                debounceTime(500),
                switchMap(data => this.getValue(data))
            )
            .subscribe((data:{key:string, value:string}[]) => {
                this.optionList = data;
                this.loading = false;
                this.cd.markForCheck();
            
            });

            if ( this.changes != null ){
                this.sub = this.changes.subscribe(changes=>{
                    this.optionList = [];
                    this.onSearch('');
                })
            }

        }

        handlingChange(evento){
            
            this.value = evento;
            this.onChange(evento);
            this.onTouched();
            this.onChangeData.emit(evento);
            
            
            if  ( evento!= null && evento!= '' ){
                if (this.searchProperties.showKey){ 
                    let ob = this.list.find(d=>d[this.searchProperties.fields.keyField] === evento);
                    this.onSelect.emit(ob)
                }else{
                    let ob = this.list.find(d=>d[this.searchProperties.fields.valueField] === evento);
                    this.onSelect.emit(ob);
                }
            }
        }

        onClear(evento){
            this.onClearData.emit(evento);
        }

        readonly compareFn = (a: any, b: any): boolean => {
            if (a == null || b == null) return a === b;

            // CASO 1: showKey = true → a e b são objetos
            if (this.searchProperties.showKey) {
                return a.key === b.key;
            }

            // CASO 2: showKey = false → a e b são strings
            return a === b;
        };

        public applyVariablesTestFormula(condition: string,variables:Variable[]) {

            let regex = new RegExp(/{@(.*?)}/g);
            var match;
        
            while ((match = regex.exec(condition)) !== null) {
            let variable:string = match[0];
            let workVariable:string =  variable.replace("{", "").replace("}", "").toUpperCase();
            
            var dataVariable:Variable = variables.find(d=>d.key.toUpperCase() == workVariable);
            
            if ( dataVariable != null  ){
                let toReplace = dataVariable.value;
                if ( toReplace == null || toReplace== undefined){
                    continue;
                }
                condition = condition.replace(variable,toReplace);
            }
            }
        
            return condition;
        }
        
        
        
        getValue(data:string): Observable<{key:string, value:string}[]> {
            if ( this.searchProperties.disabled ){
                return new Observable(observer => {
                    observer.next([]);
                });
            }
            const searchProps:SearchProperties = this.searchProperties || {
                entityName: 'Mktplaces',
                fields: { keyField: 'CODMKTP', valueField: 'NAME' }
            };
            let ob = {};
            let finder:string = 'JsonBrokerServices/find';
            if ( searchProps.type === 'mongo'){
                let variable = this.applyVariablesTestFormula(searchProps.condition, this.variables);
                let newSearchProposties = { ...searchProps, condition: variable };
                ob = {
                            "entityName": searchProps.entityName,
                            "useMongoManual": true,
                            "type":"mongo",
                            "sql": StringUtils.stringifyMongoCondition(this.applyVariablesMongo(newSearchProposties, data)),
                            "fetchSize": 0,
                            "maxRows": 1000,
                            "sort": null//,
                            //"projection": { [searchProps.fields.keyField]: 1, [searchProps.fields.valueField]: 1 }
                        };
                finder = 'JsonBrokerServices/findnative';
            }else{
                ob = {
                    entityName: searchProps.entityName,            
                    condition: this.applyVariablesTestFormula( this.applyVariables(searchProps, data), this.variables), 
                    showPresentation:searchProps.showPresentation||false,
                    showRelationshipData:false,
                    showRelationship:false,
                    showTableInformation:false,
                    
                }
            }

            return this.http.post(ob, finder, false, true, true).pipe(
                switchMap((response: any) => {
                    if ( searchProps.type == 'mongo'){
                        if (response.SQL != null) {
                            this.list = response.SQL;
                            return [this.list.map(item => ({
                                key: item[searchProps.fields.keyField],
                                value: item[searchProps.fields.valueField]
                            }))];
                        }
                    }
                    if (response[searchProps.entityName] != null) {
                        this.list = response[searchProps.entityName];
                        return [this.list.map(item => ({
                            key: item[searchProps.fields.keyField],
                            value: item[searchProps.fields.valueField]
                    }))];
                    } else {
                        return [[]];
                    }
                }),
                catchError((error) => {
                    this.loading = false;
                    throw (error);
                }),
                finalize(()=>{
                    return [[]]
                })
            );
        }

        applyVariables(fields: SearchProperties, data: any) {
            
            if (!data) {
                return fields.condition ?? '0=0';
            }

            const { keyField, valueField } = fields.fields;
            const base = fields.condition ? fields.condition + ' AND ' : '';

            // Função auxiliar para LIKE
            const likeFilter = (text: string) =>
                `(${keyField} LIKE '%${text}%' OR ${valueField} LIKE '%${text}%')`;

            // Caso showKey = false → sempre usa LIKE simples
            if (!fields.showKey) {
                return base + likeFilter(data);
            }

            // showKey = true
            let condition = fields.condition ?? '0=0';

            // Se já existe condição e há data → adiciona AND
            if (condition) {
                condition += ' AND ';
            }

            // Se data tem key → filtra por key OU continua
            if (data.key != null) {
                condition += `(${keyField} = '${data.key}' OR `;
            } else {
                condition += '(';
            }

            // Agora trata string vs objeto
            if (typeof data === 'string') {
                condition += likeFilter(data) + ')';
            } else {
                const value = data.value ?? '';
                condition += `${valueField} LIKE '%${value}%' )`;
            }

            return condition;
        }


        applyVariablesMongo(fields: SearchProperties, data: any) {
            if (!data) {
                return  JSON.parse(fields.condition) ?? {}
            }
            let cond = {};

            const { keyField, valueField } = fields.fields;
            const base = fields.condition ? cond = JSON.parse(fields.condition) : {};

            const likeFilter = (text: string) => ({
                $or: [
                    { _id: `ObjectId('${text}')`},
                    { [keyField]: { $regex: text, $options: 'i' } },
                    { [valueField]: { $regex: text, $options: 'i' } }
                ]
            });

            if (!fields.showKey) {
                return { ...base, ...likeFilter(data) };
            }

            if (data!= null && data instanceof Object){
                return {...base, [keyField]:`ObjectId('${data.key}')`} 
            }else{
                return base && data != null
                ? { ...base, $or: [{ [keyField]: data }, likeFilter(data ?? '')] }
                : { ...base, ...likeFilter(data.value ?? '') };
            }

            
        }

    }

